import React, {useEffect} from "react"
import {useParams} from "react-router-dom"
import {AsyncResultComponent} from "../containers/AsyncResult/AsyncResult"
import {TokenType, useAccessToken, useSetOnBehalfToken} from "../services/auth"
import {useAsyncResult} from "../hooks/useAsyncResult"
import {createOnBehalfToken} from "../resources/partner"
import Loading from "../components/Loading/Loading"

export function PartneOnBehalfRedirect() {
	const {orgId = ""} = useParams<{orgId: string}>()
	const accessToken = useAccessToken()
	const asyncResult = useAsyncResult(() => createOnBehalfToken(accessToken, orgId), [orgId])
	const setToken = useSetOnBehalfToken()

	useEffect(() => {
		if (asyncResult.isOk()) {
			setToken({
				accessToken: asyncResult.value.data.attributes.token,
				expires: new Date(Date.now() + asyncResult.value.data.attributes.expiresIn * 1000),
				isSSO: false,
				type: TokenType.AccessToken,
			})
			window.location.href = "/#"
		}
	}, [asyncResult])

	return (
		<AsyncResultComponent asyncResult={asyncResult} pendingComponent={<Loading />}>
			{({value: _}) => {
				return <></>
			}}
		</AsyncResultComponent>
	)
}
